import { Toaster as Sonner, ToasterProps } from 'sonner'
import { useThemeStore } from '@/stores/themeStore'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useThemeStore()

  return (
    <Sonner
      theme={theme || 'system'}
      className='toaster group'
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      richColors
      {...props}
    />
  )
}

export { Toaster }
